// src/config/contacts.js
const whatsappNumbers = {
  uberlandia: '+553433058616', // Format: countrycode + areacode + number (no spaces or dashes)
  'ribeirao-preto': 'message/FMP6A3PQTKQOK1',
};

export const getWhatsappLink = (citySlug) => {
  const number = whatsappNumbers[citySlug];
  if (number) {
    return `https://wa.me/${number}`;
  }
  return 'https://wa.me/'; // Default or fallback
};

export const getWhatsappNumber = (citySlug) => {
  return whatsappNumbers[citySlug];
};
